import React from 'react'
import Select from 'react-select'
import ListingStates from '../../constants/listings/ListingStates'

export default class ListingStateSelect extends React.Component {
  getOptions = () => {
    const { isActive } = this.props
    let ops = Object.entries(ListingStates).filter(entry => entry[1].equivalents)
    if (isActive !== undefined) ops = ops.filter(e => e[1].isActive === isActive)
    return ops
      .sort((a, b) => a[1].humanReadableName < b[1].humanReadableName)
      .map(s => ({ value: s[0], label: s[1].humanReadableName }))
  }

  getValue = () => {
    const { value } = this.props
    const valueArray = (value || '').split(',')
    return valueArray.length > 0 ? valueArray[0] : null
  }

  onChange = v => {
    const { onChange } = this.props
    const states = (ListingStates[v] || {}).equivalents || []

    onChange(states.join(','))
  }

  render() {
    return (
      <Select
        {...this.props}
        simpleValue
        onChange={this.onChange}
        value={this.getValue()}
        options={this.getOptions()}
      />
    )
  }

  static defaultProps = {
    onChange: () => {}
  }
}
